export const CompanyName = {
  SKYEER: 'skyeer',
  AVTODOR: 'avtodor',
}

export const MaptilerTokens = {
  [CompanyName.SKYEER]: 'RrFSLPCoH4Fkjw9bPMpi',
  [CompanyName.AVTODOR]: '6wrPOFlZ1admB10yPjDG',
}

export const MapBoxTokens = {
  [CompanyName.SKYEER]: 'sk.eyJ1IjoiZ3JpYjIzIiwiYSI6ImNtb3JhaHNvMjA0dXkyb3NkdWNvZjFiNG8ifQ.2ayN2CpjePE7-ctLQzDsoA',
  [CompanyName.AVTODOR]: 'sk.eyJ1IjoiZ3JpYjIzIiwiYSI6ImNtb2pzY3NzOTAyNmoycXNiMXRjNGJmMmoifQ.CmMeV175cafbL2d4kpvjVQ',
}

export const COMPANY = process.env.REACT_APP_COMPANY || CompanyName.SKYEER

const MAPTILER_TOKEN = MaptilerTokens[COMPANY]

const buildGoogleSatelliteStyle = (lang) => ({
  version: 8,
  sources: {
    'google-satellite': {
      type: 'raster',
      tiles: [
        `https://mt0.google.com/vt/lyrs=y&hl=${lang}&x={x}&y={y}&z={z}`,
        `https://mt1.google.com/vt/lyrs=y&hl=${lang}&x={x}&y={y}&z={z}`,
        `https://mt2.google.com/vt/lyrs=y&hl=${lang}&x={x}&y={y}&z={z}`,
        `https://mt3.google.com/vt/lyrs=y&hl=${lang}&x={x}&y={y}&z={z}`,
      ],
      tileSize: 256,
      attribution: '© Google',
    },
  },
  layers: [{ id: 'google-satellite-layer', type: 'raster', source: 'google-satellite' }],
})

const SatelliteStyleConfig = {
  // [CompanyName.SKYEER]: `https://api.maptiler.com/maps/019a7245-f0a3-7f60-8261-2d07d4dddcad/style.json?key=${MAPTILER_TOKEN}`,
  // [CompanyName.AVTODOR]: `/maps/avtodor/satellite-style.json`,
}

const MaptilerStyles = {
  [CompanyName.SKYEER]: {
    VECTOR: `https://api.maptiler.com/maps/019a7271-741e-750e-a289-a6e1e3ed397d/style.json?key=${MAPTILER_TOKEN}`,
    SATELLITE: SatelliteStyleConfig[CompanyName.SKYEER] ?? buildGoogleSatelliteStyle,
  },
  [CompanyName.AVTODOR]: {
    VECTOR: `/maps/avtodor/vector-style.json`,
    SATELLITE: SatelliteStyleConfig[CompanyName.AVTODOR] ?? buildGoogleSatelliteStyle,
  },
}

export const MAPTILER_STYLES = MaptilerStyles[COMPANY]
export const MAPBOX_TOKEN = MapBoxTokens[COMPANY]
